@charset "UTF-8";

/* src/app/global/layouts/layout-login/layout-login.component.scss */
:host {
  align-items: center;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  height: inherit;
  justify-content: center;
}
.cw-container-login {
  width: 420px;
}
.cw-login {
  background: var(--color-default-light) url("./media/logo_pharmakon_icon_orange_200px.svg") calc(100% + 15px) -10px/200px no-repeat;
  box-shadow: 2px 2px 5px 0px rgba(72, 72, 72, 0.45);
  padding: 120px 60px 50px 60px;
  z-index: 16000;
}
.cw-login-footer {
  margin: 5px 0 0 0;
  text-align: right;
}
/*# sourceMappingURL=layout-login.component.css.map */
